import HistorySection from "./HistorySection";
import { useFamilyHistorySection } from "../hooks/use-family-history-section";
import {
  FAMILY_HISTORY_LABELS,
  FAMILY_HISTORY_NAME_LABEL,
} from "../readmission-f2f-constant";

export interface FamilyHistorySectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  freeNoteValue?: string;
  onFreeNoteChange?: (value: string) => void;
}

const FamilyHistorySection = ({
  title,
  expanded,
  onToggle,
  freeNoteValue,
  onFreeNoteChange,
}: FamilyHistorySectionProps) => {
  const section = useFamilyHistorySection();

  return (
    <HistorySection
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      section={section}
      nameLabel={FAMILY_HISTORY_NAME_LABEL}
      labels={FAMILY_HISTORY_LABELS}
      freeNoteValue={freeNoteValue}
      onFreeNoteChange={onFreeNoteChange}
    />
  );
};

export default FamilyHistorySection;
